var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.268,
    height: 22.268,
    viewBox: "0 0 22.268 22.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.134,3A11.134,11.134,0,1,0,25.268,14.134,11.138,11.138,0,0,0,14.134,3Zm0,3.34a3.34,3.34,0,1,1-3.34,3.34A3.336,3.336,0,0,1,14.134,6.34Zm0,15.81a8.017,8.017,0,0,1-6.68-3.585c.033-2.216,4.454-3.429,6.68-3.429s6.647,1.214,6.68,3.429a8.017,8.017,0,0,1-6.68,3.585Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.6ab66cbf8bceeb4c20187d4ef705c245.svg";
export { ForwardRef as ReactComponent };